import { Component, ElementRef, ViewChild } from "@angular/core";
import { ActivityService } from "../../services/activity.service";
import { AuthenticationService, LocationPipe } from "../../../core/core";
import { ToastrService } from "ngx-toastr";
import { ActivityTypeBaseComponent } from "../activity-type-base/activity-type-base.component";
import { RentalRequest, RentalRequestService } from "../../../order/order";
import { forkJoin, map, mergeMap, of, tap } from "rxjs";
import { AzureSearchRequest, AzureSearchService } from "../../../azure-search/azure-search";
import { Account, AccountService, ContactPipe } from "../../../account/account";
import { Activity } from "../../models/activity.model";
import { generate, observe } from "fast-json-patch";

@Component({
  selector: "common-activity-renter-verification",
  templateUrl: "./activity-renter-verification.component.html",
  providers: [LocationPipe],
})
export class ActivityRenterVerificationComponent extends ActivityTypeBaseComponent {
  baseImagePath: string;

  terms = [
    {
      label: "Renter has a valid COI.",
      checked: false,
    },
    {
      label: "Renter has uploaded a valid drivers license.",
      checked: false,
    },
    {
      label: "Renter has uploaded a valid selfie.",
      checked: false,
    },
    {
      label: "Employment verification has been completed.",
      checked: false,
    },
    {
      label: "Jobsite location has been verified. (Location, Owner, Lien info)",
      checked: false,
    },
  ];
  rentalRequest: RentalRequest;
  loaded: boolean = false;
  renterAccount: Account;
  renterAccountActivities: Activity[];
  renter: any;
  orderStats: {};
  jobsiteLocation: string;

  constructor(
    activityService: ActivityService,
    authService: AuthenticationService,
    toastr: ToastrService,
    private azureSearchService: AzureSearchService,
    private rentalRequestService: RentalRequestService,
    private accountService: AccountService,
    private locationPipe: LocationPipe,
  ) {
    super(activityService, authService, toastr);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.baseImagePath = this.environment.baseImagePath;
    forkJoin({
      // rentalRequest: this.rentalRequestService.get(this.activity.rentalRequestId),
      rentalRequestIndex: this.azureSearchService.getOne(this.activity.rentalRequestId, "rental-requests"),
    })
      .pipe(
        map((result: any) => {
          this.rentalRequest = result.rentalRequestIndex;

          const partpicpant = result.rentalRequestIndex.participants.find(d => d.rentalRole === "Renter");
          this.renter = {
            ...partpicpant,
            accountId: result.rentalRequestIndex.accountId,
            accountName: result.rentalRequestIndex.accountName,
          };
          const jobsiteLocation = `http://maps.google.com/?q=${this.locationPipe.transform(this.rentalRequest.dropoffLocation, "full", false)}`;
          this.jobsiteLocation = ` <a target='blank' href='${jobsiteLocation}'>${this.locationPipe.transform(this.rentalRequest.dropoffLocation)}</a>`;

          return this.rentalRequest;
        }),
        mergeMap(rentalRequest => {
          const searchRequest = {
            ...new AzureSearchRequest(),
            select: "id, status",
            filter: `accountId eq '${rentalRequest.accountId}'`,
          };
          return forkJoin({
            renterAccount: this.accountService.get(rentalRequest.accountId),
            renterActivities: this.activityService.getAllActivitiesByAccountId(rentalRequest.accountId),
            rentalRequests: this.azureSearchService.search(searchRequest, "rental-requests"),
          });
        }),
      )
      .subscribe(renter => {
        this.renterAccount = renter.renterAccount;
        this.renterAccountActivities = renter.renterActivities;
        this.loaded = true;
        const rentalRequests = renter.rentalRequests.value as RentalRequest[];
        this.orderStats = {
          pending: rentalRequests.filter(d => d.status == "Pending")?.length || 0,
          inProgress: rentalRequests.filter(d => d.status == "Pending")?.length || 0,
          complete: rentalRequests.filter(d => d.status == "Complete")?.length || 0,
          cancelled: rentalRequests.filter(d => d.status == "Canceled")?.length || 0,
        };
      });
  }

  accountActivity(activityCode: Activity["activityCode"]) {
    return this.renterAccountActivities.find(d => d.activityCode == activityCode);
  }

  save(renterVerified: boolean) {
    const watcher = observe(this.activity);
    if (renterVerified) {
      this.activity.metadata.terms = JSON.stringify(this.terms);
    }

    this.activity.activityResponse = renterVerified.toString();
    this.activity.status = "Closed";
    this.activity.completedDateTime = new Date().toJSON();
    this.activity.completedByUserId = this.user.profile.sub;

    const patch = generate(watcher);
    this.activityService.jsonPatchWithPartitionKey(this.activity.id, patch, this.activity.accountId).subscribe(result => {
      this.toastr.success("Submitted");
      if (this.activity.metadata?.terms) {
        this.activity.metadata.terms = JSON.parse(this.activity.metadata.terms);
      }
      window.scrollTo(0, 0);
    });
  }

  notVerified() {
    if (!confirm("Are you sure renter is not verified?")) {
      return;
    }
  }

  get disableButton() {
    if (this.environment.clientId != "rubbl.admin") {
      return true;
    }

    if (!this.terms.every(d => d.checked)) {
      return true;
    }

    return false;
  }
}
